import { useContext } from "react";

import { GlobalStateContext } from "../../../utils/GlobalStateContext";

const ClientEscalationDetails = () => {
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const clientEscalationDetailsInfo =
    globalState?.eDetails && globalState?.eDetails;

  const clientEscalationDetails =
    clientEscalationDetailsInfo &&
    Object.keys(clientEscalationDetailsInfo)?.map((key) => ({
      key,
      value: clientEscalationDetailsInfo[key],
    }));

  clientEscalationDetails && clientEscalationDetails.forEach((item) => {});

  const newClientEscalation = [
    {
      key: "disputeDetails",
      title: "Dispute Details",
      fields: [
        {
          key: "client",
          label: "Client",
        },
        {
          key: "clientSpocEmail",
          label: "Client SPOC Email",
        },
        {
          key: "empID",
          label: "Emp ID",
        },
        {
          key: "financialImpact",
          label: "Financial Impact",
        },
        {
          key: "agent",
          label: "Agent",
        },
        {
          key: "auditor",
          label: "Auditor",
        },
        {
          key: "reportingTl",
          label: "Reporting TL",
        },
        {
          key: "department",
          label: "Department",
        },
        {
          key: "process",
          label: "Process",
        },
        {
          key: "errorRaiseDate",
          label: "Error Raise Date",
        },
      ],
    },
    {
      key: "transactionDetails",
      title: "Transaction Details",
      fields: [
        {
          key: "transactionId",
          label: "Transaction ID",
        },
        {
          key: "transactionDuplicateReason",
          label: "Transaction Duplicate Reason",
        },
        {
          key: "transactionDate",
          label: "Transaction Date",
        },
      ],
    },
    {
      key: "errorDetails",
      title: "Error Details",
      fields: [
        {
          key: "errorArea",
          label: "Error Area",
        },
        {
          key: "errorType",
          label: "Error Type",
        },
        {
          key: "errorDescription",
          label: "Error Description",
        },
        {
          key: "errorInvestigationRemarks",
          label: "Error investigation remarks",
        },
        {
          key: "errorImpact",
          label: "Error Impact",
        },
        {
          key: "errorStatus",
          label: "Error Status",
        },
        {
          key: "dayoftheweek",
          label: "Day of the Week",
        },
        {
          key: "agentTenure",
          label: "Agent Tenure",
        },
        {
          key: "feedbackdate",
          label: "Feedback Date",
        },
        {
          key: "repeatedError",
          label: "Repeated Error",
        },
        {
          key: "correctiveActionTaken",
          label: "Corrective Action Taken",
        },
      ],
    },
    {
      key: "rcaDetails",
      title: "RCA Details",
      fields: [
        {
          key: "rcaLevelOne",
          label: "RCA Level One",
        },
        {
          key: "rcaLevelTwo",
          label: "RCA Level Two",
        },
        {
          key: "rcaLevelThree",
          label: "RCA Level Three",
        },
        {
          key: "rcaLevelFour",
          label: "RCA Level Four",
        },
      ],
    },
    {
      key: "timestamps",
      title: "Time Stamps",
      fields: [
        {
          key: "stage",
          label: "Stage",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "createdAt",
          label: "Created At",
        },
      ],
    },
  ];

  return (
    <div className="cusClientEscalationDetails pb-16">
      {newClientEscalation.map((section) => (
        <div key={section.key} className="form-section">
          <h2 className="form-section-title">{section.title}</h2>
          <div className="cusClientEscalationDetailsWrap pb-16">
            {section.fields.map((field) => {
              const valueObj =
                clientEscalationDetails &&
                clientEscalationDetails?.find((item) => item.key === field.key);
              let value = valueObj?.value ?? "";

              // Special: format dates
              const dateKeys = [
                "errorRaiseDate",
                "transactionDate",
                "feedbackdate",
                "createdAt",
              ];
              if (dateKeys.includes(field.key) && value && value !== "") {
                value = new Date(value).toLocaleDateString();
              }

              // Special: nested user object
              if (field.key === "createdBy" && value && value.name) {
                value = value.name;
              }

              return (
                <div key={field.key} className="form-item">
                  <div className="form-label">{field.label}</div>
                  <div className="form-value">{value || "-"}</div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
export default ClientEscalationDetails;
